const header = document.querySelector('[data-mobile-nav-header]');
const button = document.querySelector('[data-mobile-nav-button]');
const nav = document.querySelector('[data-mobile-nav-navigation]');
const body = document.body;


var navIsOpen = false;

if (button) {
    button.addEventListener('click', function () {
        if (navIsOpen == false) {
            openNav();
        } else {
            closeNav();
        }
    });
}

function openNav() {
    nav.classList.remove('hidden');
    nav.classList.add('block');
    nav.classList.add('overflow-scroll');
    body.classList.add('max-lg:h-full', 'max-lg:overflow-hidden');
    button.innerHTML = 'Chiudi'

    setTimeout(() => {
        nav.classList.remove('translate-x-full');
    }, 5);

    nav.addEventListener(
        'transitionend',
        () => {
            navIsOpen = true;
        },
        { once: true },
    );
}

function closeNav() {
    nav.classList.add('translate-x-full');
    button.innerHTML = 'Menu'

    nav.addEventListener(
        'transitionend',
        () => {
            nav.classList.add('hidden');
            nav.classList.remove('block');
            nav.classList.remove('overflow-scroll');
            body.classList.remove('max-lg:h-full', 'max-lg:overflow-hidden');
            navIsOpen = false;
        },
        { once: true },
    );
}
